import {DOWNLOAD_TICKETS_BUTTON_NAMES} from '@wix/wix-events-commons-statics'

export const DOWNLOAD_TICKETS = 'DOWNLOAD_TICKETS'

export const downloadTickets = (appleWallet?: boolean) => ({
  type: DOWNLOAD_TICKETS,
  payload: {buttonName: appleWallet ? DOWNLOAD_TICKETS_BUTTON_NAMES.APPLE_WALLET : DOWNLOAD_TICKETS_BUTTON_NAMES.PDF},
})
